<div class="wrapper">
    <ul>
        @for(item of items(); track item.channel.referenceId){
        <li class="cursor-pointer font-light flex" (click)="changeChannel(item)">
            <div class="flex justify-center items-center icon-container"
                [ngClass]="{ 'highlighted': isChannelSelected(item.channel.referenceId) }">
                <img class="icon" src="{{item.channel.icon}}">
            </div>
            @if(item.currentEpg){
            <div class="flex flex-col ps-3 pe-2 justify-between content"
                [ngClass]="{ 'highlighted': isChannelSelected(item.channel.referenceId) }">
                <div class="title font-medium line-clamp-2">{{ item.currentEpg.title }}</div>
                <div class="running-time font-small">
                    {{ item.currentEpg.timeStart | date:'HH:mm' }} - {{ item.currentEpg.timeEnd | date:'HH:mm' }}
                </div>
                <div class="track me-2">
                    <div class="elapsed" data-testid="player_channels_elapsed" [ngClass]="{ 'highlighted': isChannelSelected(item.channel.referenceId) }"
                        [style.width.%]="item.elapsedPercentage">
                    </div>
                </div>
            </div>
            }
        </li>
        }
    </ul>
</div>
